const ContactSection = () => {
  return (
    <section id="contact" className="py-28 bg-gradient-to-b from-[#FFFBF0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-6">
            予約・お問い合わせ
          </h2>
          <p className="text-xl text-gray-600">
            お気軽にご相談ください
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-10 shadow-xl border-2 border-gray-100">
            <div className="mb-8 text-center">
              <p className="text-gray-700 mb-5 text-lg">
                下記のフォームからご予約・お問い合わせいただけます
              </p>
              <a
                href="https://forms.gle/GhVW4bdAesTPtY9p9"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-brand-yellow hover:text-brand-yellow-dark font-bold transition-all duration-300 hover:scale-105"
              >
                新しいタブで開く
                <i className="ri-external-link-line"></i>
              </a>
            </div>

            <div className="w-full rounded-2xl overflow-hidden shadow-lg" style={{ height: '800px' }}>
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSe3YLb1C3x5eorCyM7OBYCNXAAVLQII_ymWQiPUH-M-86S6yQ/viewform?embedded=true"
                width="100%"
                height="100%"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                className="rounded-2xl"
              >
                読み込んでいます…
              </iframe>
            </div>
          </div>

          <div className="mt-16 grid md:grid-cols-2 gap-8">
            <div className="text-center p-8 bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-gray-100 hover:border-[#00B900]/30 hover:-translate-y-2 group">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 bg-[#00B900]/10 group-hover:scale-110 transition-transform duration-300">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/4/41/LINE_logo.svg" 
                  alt="LINE" 
                  className="w-12 h-12 object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold text-brand-dark mb-3">LINE</h3>
              <p className="text-gray-600 mb-6 text-base">LINEでもお問い合わせ可能</p>
              <a
                href="https://line.me/R/ti/p/@251xqjgz?_gl=1*8soeuu*_gcl_au*MTUyNTMzMzgwOC4xNzU5NzQyMTgz*_ga*NjgyMTMyNjIuMTc1OTc0MjE4NA..*_ga_0PV16Y9CZG*czE3NjQ3NTgwMzUkbzIkZzAkdDE3NjQ3NTgwNDEkajU0JGwwJGgw"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#00B900] hover:text-[#009900] font-bold whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
              >
                LINEで相談
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="text-center p-8 bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-gray-100 hover:border-[#E1306C]/30 hover:-translate-y-2 group">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 bg-[#E1306C]/10 group-hover:scale-110 transition-transform duration-300">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" 
                  alt="Instagram" 
                  className="w-12 h-12 object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold text-brand-dark mb-3">Instagram</h3>
              <p className="text-gray-600 mb-6 text-base">最新情報をチェック</p>
              <a
                href="https://www.instagram.com/sotomago_official/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#E1306C] hover:text-[#C13584] font-bold whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
              >
                Instagramを見る
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
